/*
Name		: quizBody.jsx
Created By	: Stephen Amey
Date		: May 16, 2018
----------------------------------------------------------------------------------------------------------------------------------------
Description	: 
	Quiz body that contains the quiz, and applies some CSS styling.
	Has a print button so that the quiz can be printed and completed by hand
----------------------------------------------------------------------------------------------------------------------------------------
Modification history (- Name, Date : Changes) :


*/

import React from 'react';
import { Grid, Panel } from 'react-bootstrap';
import econQuiz from ".\\quiz.jsx";
import * as Survey from "survey-react";
import printJS from 'print-js';
import '..\\CSS\\econ.css';
import printPDF from '..\\Post-test for economics.pdf';

const style = {
	quizCSS: {
		row: "quiz-row",
	},
	bodySize: {
		width: "85%"
	},
};

export default class quizBody extends React.Component{
	render() {
		Survey.Survey.cssType = "bootstrap";
		return (
			<Grid style={style.bodySize}>
				<Panel bsStyle="custom">
					<Panel.Heading>Self-Assessment Multiple Choice Quiz 2</Panel.Heading>
					<Survey.Survey css={style.quizCSS}  model={econQuiz}/>
				</Panel>
				<div>
					<button onClick={() => 
					{
						printJS(printPDF);
					}
					}>PRINT</button>
				</div>
			</Grid>			
		);
	}
}


// WEBPACK FOOTER //
// ./src/Components/quizBody.jsx